import React from 'react';
// import { Link } from 'react-router-dom';
import './footer.styles.scss';
// import { ReactComponent as FacebookIcon } from '../../svg/facebook2.svg';
// import { ReactComponent as TwitterIcon } from '../../svg/twitter.svg';
// import { ReactComponent as InstegramIcon } from '../../svg/instegram.svg';
// import { ReactComponent as GpsIcon } from '../../svg/gps.svg';
// import { ReactComponent as PlaystoreIcon } from '../../svg/android.svg';
// import { ReactComponent as AppstoreIcon } from '../../svg/apple.svg';
// import { ReactComponent as YoutubeIcon } from '../../svg/youtube2.svg';


const Footer = () => (
    <div className='footer'>
        <div className='options'>
            {/* <Link to='/wiztwitter'><TwitterIcon className='icon'/></Link>
            <Link to='/wizfacebook'><FacebookIcon className='icon'/></Link>
            <Link to='/wizyoutube'><YoutubeIcon className='icon'/></Link>
            <Link to='/dargps'><GpsIcon className='icon'/></Link>
            <Link to='/appstore'><AppstoreIcon className='icon'/></Link>
            <Link to='/googleplay'><PlaystoreIcon className='icon'/></Link> */}
            
            <h2 className='copy-right whiteText' >  Copy right © 2021 - HSAAA</h2>
        </div>
    </div>
)
export default Footer;